import React from "react";
import "../css/Modal.css";
import modalClose from "../assets/img/modal_close.png";

function ModalConfirmMessage({ onClose }) {
  return (
    <div className="modal_wrap">
      <div className="modal_container" style={{ width: "500px" }}>
        <button className="modal_close" onClick={onClose}>
          <img src={modalClose} alt="닫기 버튼" />
        </button>
        <div className="modal_header">
          <p>구독 신청 완료</p>
        </div>
        <div
          className="modal_box"
          style={{ padding: "44px 72px", textAlign: "center" }}
        >
          <p>
            📩 입력하신 이메일로
            <br />
            확인 메일을 발송했습니다.
          </p>
          <p>메일함을 확인해주세요.</p>
          <button
            className="sub_btn"
            onClick={onClose}
            style={{ marginTop: "24px" }}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalConfirmMessage;
